/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
import Link from 'next/link'
import React, { ReactNode, useRef, useState } from 'react'

import { Card, CardProps } from '../Card'

export interface LaneProps {
    title?: string
    titleIconComponent?: () => ReactNode
    description?: string
    data?: Array<CardProps>
    CustomContent?: unknown
    customItemWidth?: string
    seeAllHref?: string
    hideArrows?: boolean
}

function useScrollDrag() {
    const ref: any = useRef()
    const [initMouseX, setinitMouseX] = useState(0)
    const [initScrollX, setInitScrollX] = useState(0)

    const events = {
        ref: ref,
        onMouseDown: ({ nativeEvent: e }: any) => {
            setinitMouseX(e.clientX)
            setInitScrollX(ref.current.scrollLeft)
        },
        onMouseMove: ({ nativeEvent: e }: any) => {
            if (e.buttons > 0) {
                e.preventDefault()
                ref.current.scrollTo({
                    left: initScrollX + initMouseX - e.clientX,
                    behavior: 'smooth'
                })
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return [events, ref]
}

export const Lane = ({
    data,
    CustomContent,
    title = null,
    titleIconComponent = null,
    description = null,
    seeAllHref,
    hideArrows = false,
    customItemWidth
}: LaneProps) => {
    const [bind] = useScrollDrag()

    return (
        <div className="pl-2 md:pl-14">
            <div className="flex justify-between items-center">
                {title && (
                    <div className="flex items-center mb-2">
                        {titleIconComponent && (
                            <>
                                {titleIconComponent()}
                                <div className="mr-3" />
                            </>
                        )}
                        <p className="text-gray-800 font-medium text-xl md:text-3xl">
                            {title}
                        </p>
                    </div>
                )}
                {seeAllHref && (
                    <div className="mb-5 mr-5">
                        <Link href={seeAllHref} passHref>
                            <a
                                onClick={() => window.scrollTo(0, 0)}
                                className="underline text-gray-600 font-normal text-lg md:text-xl "
                            >
                                See All
                            </a>
                        </Link>
                    </div>
                )}
            </div>
            <div
                className={`box-border grid grid-cols-1 relative ${
                    description ? 'gap-10' : 'gap-0'
                }`}
            >
                {description && (
                    <div className="lg:max-w-[850px]">
                        <p className="font-normal text-lg leading-8 text-gray-800 pr-6 md:pr-6 lg:pr-0">
                            {description}
                        </p>
                    </div>
                )}

                <ul
                    className={`lane list-none m-0 grid grid-flow-col ${
                        customItemWidth ? customItemWidth : 'auto-cols-card'
                    } overflow-x-scroll pb-10 cursor-move relative`}
                    style={{
                        scrollSnapType: 'x mandatory',
                        scrollPadding: '0 1rem',
                        WebkitOverflowScrolling: 'touch',
                        cursor: 'grab'
                    }}
                    key={title}
                    {...bind}
                >
                    {CustomContent
                        ? CustomContent
                        : data?.map((item, idx) => {
                              return (
                                  <li style={{ scrollSnapAlign: 'start' }} key={idx}>
                                      <Card key={item.title + idx} {...item} />
                                  </li>
                              )
                          })}
                </ul>
                {!hideArrows ? (
                    <>
                        <div
                            className={`hidden md:flex absolute top-0 w-16 h-[88%]  opacity-0 hover:opacity-70 items-center justify-center z-50 transition-all cursor-pointer ${
                                description && 'md:left-[0px]'
                            }`}
                            onClick={() => {
                                bind.ref.current.scrollTo({
                                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                    left: bind.ref.current.scrollLeft - 240,
                                    behavior: 'smooth'
                                })
                            }}
                        >
                            <div className="bg-black cursor-pointer rounded-full w-[52px] h-[52px] flex items-center justify-center">
                                <i
                                    aria-hidden
                                    className="far fa-angle-left text-[40px] leading-none p-0 text-white mr-[3px] mt-[3px]"
                                ></i>
                            </div>
                        </div>
                        <div
                            className="hidden md:flex absolute right-0 top-0 w-16 h-[88%]  opacity-0 hover:opacity-70 items-center justify-center z-50 transition-all cursor-pointer"
                            onClick={() => {
                                bind.ref.current.scrollTo({
                                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                    left: bind.ref.current.scrollLeft + 240,
                                    behavior: 'smooth'
                                })
                            }}
                        >
                            <div className="bg-black cursor-pointer rounded-full w-[52px] h-[52px] flex items-center justify-center">
                                <i
                                    aria-hidden
                                    className="far fa-angle-right text-[40px] leading-none p-0 text-white mr-[-3px] mt-[3px]"
                                ></i>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    )
}
